import { render, staticRenderFns } from "./seniorCard.vue?vue&type=template&id=aaa298c8&scoped=true&"
import script from "./seniorCard.vue?vue&type=script&lang=js&"
export * from "./seniorCard.vue?vue&type=script&lang=js&"
import style0 from "./seniorCard.vue?vue&type=style&index=0&id=aaa298c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaa298c8",
  null
  
)

export default component.exports